const OnboardingActions = {
  global : {
    CurrentView :       "APP_CURRENT_VIEW",
    UserAuthenticated : "USER_AUTHENTICATED",
    SessionStarted :    "SESSION_STARTED",
    SessionEnded :      "SESSION_ENDED",
    Next :              "NEXT",
    Click:              "CLICK",
    DataCaptured:       "DATACAPTURED",
    FatalError:         "FATAL_ERROR"
  },

  // REGISTRATION View
  UserLoaded :                       "USER_LOADED",
  UserCreated :                      "USER_CREATED",
  UserUpdated :                      "USER_UPDATED",
  GoToRedirector :                   "GO_TO_REDIRECTOR",
  HasRegistrartionValidationError :  "HAS_REGISTRARTION_VALIDATION_ERROR",
  CmExists :                         "CM_EXISTS",
  CmExistsByPhone :                  "CM_EXISTS_BY_PHONE",
  AcceptConfidentAgreement:          "ACCEPTCONFIDENTAGREEMENT",
  AcceptTerms:                       "ACCEPTTERMS",
  HasGoodPassword:                   "HAS_GOOD_PASSWORD",
  HasBadPassword:                    "HAS_BAD_PASSWORD",
  HasFormError:                      "HAS_FORM_ERROR",


  // RESUME Actions
  FileSelected:         "FILE_SELECTED",
  UploadStarted :       "UPLOAD_STARTED",
  UploadCompleted :     "UPLOAD_COMPLETED",
  UploadError :         "UPLOAD_ERROR",
  UploadFileTypeError : "UPLOAD_FILE_TYPE_ERROR",
  ResetResumeView :     "RESET_RESUME_VIEW",
  ResumeURLAdded :      "RESUME_URL_ADDED",
  ResumeURLError :      "RESUME_URL_ERROR",

  SAVELINKEDINURL:          "SAVE_LINKEDIN_URL",
  LINKEDINURLERROR:         "LINKEDIN_URL_ERROR",

  // Manual Entry Actions
  ManualEntryDisplayed :         "MANUAL_ENTRY_DISPLAYED",
  ManualEntryCanceled :          "MANUAL_ENTRY_CANCELED",
  ManualEntryError :             "MANUAL_ENTRY_ERROR",
  ManualEntrySubmitAttempts :    "MANUAL_ENTRY_SUBMITATTEMPTS",
  ManualEntrySubmitSuccess :     "MANUAL_ENTRY_SUBMITSUCCESS",
  ManualEntrySubmitError :       "MANUAL_ENTRY_SUBMITERROR",

  // RATE view
  SelectSalary:               "SELECT_SALARY",
  RateChanged:                "RATE_CHANGED",
  SubmitRate:                 "SUBMIT_RATE",
  AcceptSuggestedRate:        "ACCEPT_SUGGESTED_RATE",
  SubmitRateForApproval:      "SUBMIT_RATE_FOR_APPROVAL",
  ReminderNoReminder:         "REMINDER_NO_REMINDER",
  ReminderSelected:           "REMINDER_SELECTED",
  ReminderSet:                "REMINDER_SET",
  ModalTooHighDisplay:        "MODAL_TOO_HIGH_DISPLAYED",
  ModalDoneDisplayed:         "MODAL_DONE_DISPLAYED",
  ModalRemiderDisplayed:      "MODAL_REMINDER_DISPLAYED",
  ModaWhatsNextDisplayed:     "MODAL_WHATS_NEXT_DISPLAYED",
}

export default OnboardingActions;